export default __webpack_public_path__ + "static/media/healthscore-icon-excellent.ae383e94.svg";